import { render, staticRenderFns } from "./ProductView.vue?vue&type=template&id=54304f5d&scoped=true"
import script from "./ProductView.vue?vue&type=script&lang=js"
export * from "./ProductView.vue?vue&type=script&lang=js"
import style0 from "./ProductView.vue?vue&type=style&index=0&id=54304f5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54304f5d",
  null
  
)

export default component.exports